@let navigationItems = navigationItems$ | async;
@let menuItems = menuItems$ | async;
@let menuAndNavigationItems = menuAndNavigationItems$ | async;
@let isMobile = isMobile$ | async;

@if (isDevelopment) {
	<div class="dev-banner">
		<strong>Development Environment</strong>
	</div>
}

@if (menuAndNavigationItems && navigationItems && menuItems) {
	<p-menubar [dt]="menubarHeaderDesignToken" [model]="isMobile ? [] : navigationItems" [breakpoint]="breakpoint">
		<ng-template #start>
			<a routerLink="/">
				<div class="title">{{ title + ((isStaging$ | async) ? ' - Staging' : '') }}</div>
			</a>
		</ng-template>
		<ng-template #end>
			<div class="end-items">
				@if (isMobile) {
					<a [href]="homeUrl">
						<div>
							<img class="traton-logo-mobile" alt="Traton logo" src="assets/logos/svg/TRATON_Super_sign_RGB_White.svg" />
						</div>
					</a>
				} @else {
					<a [href]="homeUrl">
						<div>
							<img class="traton-logo" alt="Traton logo" src="assets/logos/svg/TRATON_Logo_RGB_white.svg" />
						</div>
					</a>
				}
				<p-button #menuButton raised="true" severity="secondary" variant="outlined" size="small" icon="pi pi-bars" (onClick)="menu.toggle($event)" />
			</div>
			<p-tieredmenu #menu [dt]="menuHeaderDesignToken" popup="true" [model]="isMobile ? menuAndNavigationItems : menuItems" appendTo="body" />
		</ng-template>
	</p-menubar>
	@if (authService.userData$ | async; as userData) {
		<p-drawer [dt]="drawerHeaderDesignToken" header="User details" [(visible)]="showUserDetails" appendTo="body" [modal]="true" [position]="isMobile ? 'full' : 'right'" closable="true">
			@defer (when showUserDetails) {
				@if (userData) {
					<div class="table-container">
						<div>
							<table>
								<tr>
									<td class="table-row">Name</td>
									<td class="table-row">{{ userData?.firstName }} {{ userData?.lastName }}</td>
								</tr>
								<tr>
									<td class="table-row">Company</td>
									<td class="table-row">{{ userData?.companyName }}</td>
								</tr>
								<tr>
									<td class="table-row">Username</td>
									<td class="table-row">{{ userData?.userName }}</td>
								</tr>
							</table>
						</div>
						<div class="table-title">
							<h4><b>Functional groups</b></h4>
						</div>
					</div>
				} @else {
					<div style="align-items: center; display: flex">
						<p-progressSpinner />
					</div>
				}
			}
		</p-drawer>
	}

	<p-drawer [dt]="drawerHeaderDesignToken" header="Settings" [(visible)]="showSettings" appendTo="body" [modal]="true" [position]="isMobile ? 'full' : 'right'" closable="true">
		@if (preferences$ | async) {
			<div class="table-container">
				<div class="table-content">
					<table>
						@if (stagingAvailable$ | async) {
							<tr>
								<td class="table-row">Staging</td>
								<td class="table-row"><p-toggle-switch [(ngModel)]="isStaging" (onChange)="preferencesService.toggleStaging()" /></td>
							</tr>
						}
						<tr>
							<td class="table-row">Theme</td>
							<td class="table-row">
								@if (themeService.theme$ | async; as theme) {
									<p-toggleSwitch [ngModel]="theme === Theme.Light" (onChange)="themeService.toggleTheme()">
										<ng-template pTemplate="themeSwitch">
											<i class="pi" [ngClass]="theme === Theme.Light ? 'pi pi-sun' : 'pi pi-moon'"></i>
										</ng-template>
									</p-toggleSwitch>
								}
							</td>
						</tr>
					</table>
				</div>
			</div>
		}
	</p-drawer>
}
